export const MACHINE_ALERT_TEXT = {
  nl: {
    line: ({ machineId, totalBoxes }) =>
      `Machine ${machineId} heeft nog ${totalBoxes} kisten.`,
  },

  en: {
    line: ({ machineId, totalBoxes }) =>
      `Machine ${machineId} has ${totalBoxes} boxes left.`,
  },

  pl: {
    line: ({ machineId, totalBoxes }) =>
      `Maszyna ${machineId} ma jeszcze ${totalBoxes} skrzynek.`,
  },
};

export function getMachineAlertText(alert, lang = "nl") {
  if (!alert?.alerts?.length) return "";

  const t = MACHINE_ALERT_TEXT[lang] || MACHINE_ALERT_TEXT.nl;
  return alert.alerts.map((item) => t.line(item)).join("\n\n");
}
